module.exports = __webpack_public_path__ + "static/media/icon_grid.711bd20a.png";